export default __webpack_public_path__ + "static/media/what-is-mobile.b632dd62.png";